<template>
<div>
  <b-container class="box">
    <b-row align-h="center" class="adjustLoc">
      <b-col cols="12">
        <b-row>
          <b-col class="text-center">
            <h2><span style="color:green; font-weight: bold;">Congrats!</span> You are pre-approved for your car repair loan!</h2>
          </b-col>
        </b-row>
        <b-row>

          <b-col>
            <h3 v-show="cashStatus">Cash amount required: {{cashReady}}$</h3>
            <h3>Repair amount: {{repairAmount}}$</h3>
            <h3><span style="color:green;">Approved amount:</span> {{boundaryLimit}}$</h3>

            <!-- Loan amount and Pay by Cash titles -->
          </b-col>
        </b-row>
        <input id="phone_number" ref="phone_number" v-model="input.phone_number" type="text" class="frmField" placeholder="Phone number">
        <input id="email" v-model="input.email" type="email" name="email" class="frmField" placeholder="Enter email address">
        <b-col class="text-center">
  <p v-if="errors.length">
    <br>
      <b>Please correct the following error(s):</b>
      <span style="color: red">
        <li v-for="error in errors">{{ error }}</li>
    </span>
    </p>
</b-col>
<div class="form-group" style="text-align: left; margin-top: 1rem;">
  <label>
    <input
      id="smsOptIn"
      v-model="smsOptIn"
      type="checkbox"
      :class="{ 'is-invalid': smsOptInError }"
      style="margin-right: 5px;"
    />
    <span style="color:black">I agree to receive communication by text message about my inquiry or payment reminders if I sign up for the service. You May opt-out by replying STOP or reply HELP for more information. Message frequency vaires. Message and data rates may apply. You may review our <a href="/privacy-policy">Privacy Policy</a> to learn how you data is used.
    </span>
  </label>
  <div v-if="smsOptInError" class="invalid-feedback">
    You must agree to receive SMS messages to submit the form.
  </div>
</div>
        <button class="btn btn-success" @click="checkForm">
          Create User
        </button>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>
<script>
import $ from 'jquery'
import Loading from '../components/loading'

export default {
  name: 'UserCreate',
  components: {
    Loading,
  },
  data() {
    return {
      smsOptInError: false,
      smsOptIn: this.smsOptIn, // Include smsOptIn in the data sent
      address: 'Address',
      country: 'Country',
      city: 'City',
      zip_code: 'Zip Code',
      province: 'Province',
      employment: 'Employment',
      errors: [],
      vendorOfUser: '',
      frequency: '',
      cashStatus: false,
      currentYear: '',
      loanRatio: '',
      approvedLoan: '',
      maxLoanAmount: '',
      finalLoanAmount: '',
      cashReady: '',
      repairAmount: '',
      boundaryLimit: '',
      minimumLoan: '',
      visible: false,
      input: {
        first_name: 'First Name',
        last_name: 'Last Name',
        email: null,
        phone_number: null,
        password: Math.random()
          .toString(36)
          .slice(-5),
      },
      show: false,
    }
  },
  watch: {
    smsOptIn(val) {
    if (val) {
      this.smsOptInError = false
    }
  },
    'input.email': {
      handler: function(after, before) {
        this.input.email = this.input.email.toLowerCase()
      },
      deep: true,
    },
  },
  created() {
    if (!this.$store.state.userData.carDetails) {
      this.$router.push({
        name: 'Home',
      })
    }
    $('.navbar').addClass('darkHeader')
    this.$refs.phone_number.focus()
    const {
      year,
      make,
      model,
      trim: trim_level,
      vehicleStyle: vehicle_style,
      vin,
      odometerReading: odometer_reading,
      carDetails: car_details,
      payment: loan_amount,
      paymentFrequency: frequency,
      numberOfPayments: number_of_payments,
      paymentTotal: payment_total,
      boundaryAmount: boundary_amount,
      approvedLoanAmount: max_loan_amount,
      loanRequested: loan_requested,
      repairOfferAmount: repair_offer_amount,
      paymentPeriod: term,
      newAPR: new_apr,
      vendorToPay: vendor_to_pay,
      ninetyDays: ninety_days,
      firstPaymentDay: first_payment_day,
      totalPayments: total_payments,
      costOfFinancing: cost_of_financing,
      frequencyText: frequency_text,
      paymentFees: payment_fees,
      selectedVendor: vendor,
    } = this.$store.state.userData
  },
  mounted() {
    console.log('Data ' + this.$store.state.userData)
    this.vendorOfUser = this.$store.state.userData.selectedVendor
    console.log('this is the vendor' + this.vendorOfUser)
    this.currentYear = new Date().getFullYear()
    this.loanRatio = 1 - (this.currentYear - this.$store.state.userData.year) / 35
    this.approvedLoan = Math.max(
      1500,
      Math.trunc(this.$store.state.userData.marketValue * 0.3 * 0.7 * this.loanRatio)
    )
    this.repairAmount = this.$store.state.userData.repairOfferAmount
    // Check the maximum amount possible to take if the approved loan is lower than the repair offer
    this.maxLoanAmount =
      this.approvedLoan > this.repairAmount ? this.repairAmount : this.approvedLoan
    this.$store.state.userData.approvedLoanAmount =
      this.approvedLoan > 10000 ? 10000 : this.approvedLoan
    console.log(this.$store.state.userData.approvedLoanAmount)
    this.boundaryLimit = this.maxLoanAmount > 10000 ? 10000 : this.maxLoanAmount
    // Check if the customer needs to bring cash because his approved amount doesn't cover the repair offer
    this.minimumLoan =
      this.approvedLoan > this.repairAmount ? 500 : this.repairAmount - this.approvedLoan
    // set default highest loan possible
    this.finalLoanAmount = this.boundaryLimit
    // store the data
    this.$store.state.userData.boundaryAmount =
      this.approvedLoan > 10000 ? 10000 : this.approvedLoan
    this.$store.state.userData.paymentTotal = this.finalLoanAmount
    this.paymentFrequency = this.$store.state.userData.paymentFrequency
    // is the below line important?

    const {
      year,
      make,
      model,
      trim: trim_level,
      vehicleStyle: vehicle_style,
      vin,
      odometerReading: odometer_reading,
      carDetails: car_details,
      payment: loan_amount,
      paymentFrequency: frequency,
      numberOfPayments: number_of_payments,
      paymentTotal: payment_total,
      boundaryAmount: boundary_amount,
      approvedLoanAmount: max_loan_amount,
      loanRequested: loan_requested,
      repairOfferAmount: repair_offer_amount,
      paymentPeriod: term,
      newAPR: new_apr,
      vendorToPay: vendor_to_pay,
      ninetyDays: ninety_days,
      firstPaymentDay: first_payment_day,
      totalPayments: total_payments,
      costOfFinancing: cost_of_financing,
      frequencyText: frequency_text,
      paymentFees: payment_fees,
      selectedVendor: vendor,
    } = this.$store.state.userData

    console.log(
      'LOAN DATA: ' +
        '  -1 ' +
        year +
        '  -2 ' +
        make +
        '  -3 ' +
        model +
        '  -4 ' +
        trim_level +
        '  -5 ' +
        vehicle_style +
        '  -6 ' +
        vin +
        '  -7 ' +
        odometer_reading +
        '  -8 ' +
        car_details +
        '  -9 ' +
        loan_amount +
        '  -10 ' +
        frequency +
        '  -11 ' +
        number_of_payments +
        '  -12 ' +
        payment_total +
        '  -13 ' +
        boundary_amount +
        '  -14 ' +
        max_loan_amount +
        '  -15 ' +
        loan_requested +
        '  -16 ' +
        repair_offer_amount +
        '  -18' +
        term +
        '  -19 ' +
        new_apr +
        '  -20 ' +
        vendor_to_pay +
        '  -21 ' +
        first_payment_day +
        '  -22 ' +
        total_payments +
        '  -23 ' +
        cost_of_financing +
        '  -24 ' +
        frequency_text +
        '  -25 ' +
        payment_fees +
        '  -26 ' +
        vendor +
        '  -27 ' +
        ninety_days
    )
  },
  methods: {
    validEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },

    checkForm: function(e) {
      this.errors = []
      if (!this.input.first_name) {
        this.errors.push('First Name required.')
      }
      if (!this.input.last_name) {
        this.errors.push('Last Name required.')
      }
      if (!this.input.password) {
        this.errors.push('Password required.')
      }
      if (!this.smsOptIn) {
        this.smsOptInError = true
        this.errors.push('You must agree to receive SMS messages to submit the form.')
        this.$nextTick(() => {
          document.getElementById('smsOptIn').focus()
        })
      }
      if (!this.input.email) {
        this.errors.push('Email required.')
      } else if (!this.validEmail(this.input.email)) {
        this.errors.push('Valid email required.')
      }
      if (!this.errors.length) {
        this.axios
          .post(`${process.env.ROOT_API}/user/create`, {
            first_name: this.input.first_name,
            last_name: this.input.last_name,
            email: this.input.email,
            password: this.input.password,
            vendor_of_user: this.vendorOfUser,
            phone_number: this.input.phone_number,
          })
          .then(response => {
            localStorage.setItem('user-id', response.data.data.id)
            localStorage.setItem('user-token', response.data.data.token)
            const id = localStorage.getItem('user-id')
            const token = localStorage.getItem('user-token')
            const updateUserPromise = this.axios.put(
              `${process.env.ROOT_API}/user/${id}`,
              {
                address: this.address,
                city: this.city,
                zip_code: this.zip_code,
                province: this.province,
                country: this.country,
                employment: this.employment,
              },
              {
                headers: {
                  authorization: `Token ${token}`,
                },
              }
            )

            const {
              year,
              make,
              model,
              trim: trim_level,
              vehicleStyle: vehicle_style,
              vin,
              odometerReading: odometer_reading,
              carDetails: car_details,
              payment: loan_amount,
              paymentFrequency: frequency,
              numberOfPayments: number_of_payments,
              paymentTotal: payment_total,
              boundaryAmount: boundary_amount,
              approvedLoanAmount: max_loan_amount,
              loanRequested: loan_requested,
              repairOfferAmount: repair_offer_amount,
              paymentPeriod: term,
              newAPR: new_apr,
              vendorToPay: vendor_to_pay,
              ninetyDays: ninety_days,
              firstPaymentDay: first_payment_day,
              totalPayments: total_payments,
              costOfFinancing: cost_of_financing,
              frequencyText: frequency_text,
              paymentFees: payment_fees,
              selectedVendor: vendor,
            } = this.$store.state.userData

            const createLoanPromise = this.axios.post(
              `${process.env.ROOT_API}/user/loan/create`,
              {
                make,
                model,
                year,
                trim_level,
                vin,
                car_details,
                vehicle_style,
                odometer_reading,
                loan_amount,
                frequency,
                number_of_payments,
                payment_total,
                boundary_amount,
                max_loan_amount,
                loan_requested,
                repair_offer_amount,
                term,
                term_type: 'months',
                new_apr,
                vendor_to_pay,
                ninety_days,
                first_payment_day,
                total_payments,
                cost_of_financing,
                frequency_text,
                vendor: vendor || localStorage.getItem('vendor'),
              },
              {
                headers: {
                  authorization: `Token ${token}`,
                },
              }
            )

            Promise.all([updateUserPromise, createLoanPromise]).then(() => {
              location.href = `${process.env.DASHBOARD_URL}/#/login?token=${token}`
            })
          })
          .catch(error => {
            if (error.message === 'Request failed with status code 409') {
              this.$toasted.show('User with this email already exists')
            } else {
              this.$toasted.show('An error occurred please try again')
            }
          })
      } /* error length */
      e.preventDefault()
    } /* function e */,
  } /* method */,
} /* export default */
</script>

<style scoped>
.is-invalid {
  border-color: red;
}
.invalid-feedback {
  color: red;
  margin-top: 5px;
}
.formback {
  background-color: white;
}
@media (max-width: 560px) {
  .estisize {
  }
  .adjustLoc {
    width: 350px;
    padding-top: 4rem;
  }
}

@media (min-width: 561px) and (max-width: 767px) {
  .estisize {
    width: 340px;
  }
  .adjustLoc {
    padding-top: 4rem;
  }
}

@media (min-width: 768px) and (max-width: 979px) {
  .estisize {
    width: 340px;
  }
  .adjustLoc {
    padding-top: 4rem;
  }
}

@media (min-width: 980px) and (max-width: 1399px) {
  .estisize {
    width: 340px;
  }
  .adjustLoc {
    padding-top: 4rem;
  }
}

@media (min-width: 1400px) {
  .estisize {
    width: 340px;
  }
  .adjustLoc {
    padding-top: 4rem;
  }
}

.element-margin {
  /* margin-bottom: 8%; */
  text-align: center;
}

.container {
  width: 340px;
  color: #ffffff;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
}

.frmField {
  background-color: white;
  color: #495057;
  line-height: 1.25;
  font-size: 16px;
  font-family: 'Roboto', sans-serif;
  border: 0;
  padding: 10px;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  width: 90%;
}

.Password_field {
  margin-top: 1rem;
}

select,
input {
  max-width: 340px;
  margin: 1rem auto 0 auto;
}

#retype_password {
  margin: 0 auto 0 auto;
}

select:focus,
input:focus {
  box-shadow: none;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 4rem;
  color: #fff;
  margin: 0 auto;
  display: block;
  margin-top: 1rem;
}

h3 {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #7b7e7d;
}

.awesome {
  color: #40c991;
}

.flow-title {
  /* padding-top: 5%; */
}

.element-margin {
  /* margin-bottom: 13%; */
  text-align: center;
}

.element-center {
  margin: 0 auto;
}

.box {
  text-align: center;
  padding-top: 1rem;
  padding-bottom: 2rem;
  width: 700px;
}

.box .separator .line {
  width: 1px;
  height: 40%;
  background-color: #a803a8;
  /* margin: 0 auto; */
}

.box .separator .or {
  /* margin: 0 auto; */
  width: fit-content;
  height: 10%;
  display: flex;
  align-items: center;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 3rem;
  color: #fff;
}

.input-icon {
  position: relative;
}

.input-icon > i {
  position: absolute;
  display: block;
  transform: translate(0, -50%);
  top: 50%;
  pointer-events: none;
  width: 25px;
  text-align: center;
  font-style: normal;
}

.input-icon > input {
  padding-left: 25px;
  padding-right: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}

ele div.x {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  display: inline;
  float: right;
}

.ele div.x.slow {
  -webkit-transition-duration: 1s;
  transition-duration: 1s;
}

ul {
  list-style: none;
  float: right;
  display: block;
  width: 100%;
}

li {
  display: inline;
  width: 25%;
  float: right;
}

.ele {
  width: 25%;
  display: inline;
}

.x {
  float: left;
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: #ccc;
  border-radius: 2px;
  border: solid 2px #fff;
  transition: all 0.3s ease-out;
  cursor: pointer;
}

.x.large {
  width: 33px;
  height: 33px;
}

.x.medium {
  width: 20px;
  height: 20px;
}

.x.small {
  width: 10px;
  height: 10px;
}

.x.switch {
  width: 15px;
  height: 15px;
}

.x.grow {
}

.x.spin:hover {
  background: #40c991;
  transform: rotate(180deg);
}

.x.flop:hover {
  background: #40c991;
  transform: rotate(90deg);
}

.x.t:hover {
  background: #40c991;
  transform: rotate(45deg);
}

.x.shift:hover {
  background: #40c991;
}

.x b {
  display: block;
  position: absolute;
  height: 0;
  width: 0;
  padding: 0;
  margin: 0;
}

.x.small b {
  border: solid 5px rgba(255, 255, 255, 0);
}

.x.medium b {
  border: solid 10px rgba(255, 255, 255, 0);
}

.x.large b {
  border: solid 15px rgba(255, 255, 255, 0);
}

.x.switch b {
  border: solid 10px rgba(255, 255, 255, 0);
}

.x b:nth-child(1) {
  border-top-color: #fff;
  top: -2px;
}

.x b:nth-child(2) {
  border-left-color: #fff;
  left: -2px;
}

.x b:nth-child(3) {
  border-bottom-color: #fff;
  bottom: -2px;
}

.x b:nth-child(4) {
  border-right-color: #fff;
  right: -2px;
}

.checkmark {
  display: block;
  margin: 0 auto;
  text-align: center;
}

.checkmark:after {
  content: '';
  display: block;
  border: solid #000;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkmark.large:after {
  width: 12px;
  height: 24px;
}

.checkmark.medium:after {
  width: 8px;
  height: 16px;
}

.checkmark.small:after {
  width: 4px;
  height: 8px;
}

.checkmark.tiny:after {
  width: 1px;
  height: 2px;
  border-width: 0 1px 1px 0;
}
.lds-roller {
  position: absolute !important;
  display: inline !important;
  right: 120px;
}
.titleBox {
  padding-top: 2rem;
}
.error {
  padding: 15px 0;
  color: red;
}

.error.hide {
  display: none;
}

.flow-title {
  padding-top: 2%;
}

.element-margin {
  margin-bottom: 8%;
  text-align: center;
}

.element-center {
  margin: 0 auto;
}

.container {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.box {
  /* padding: 6rem; */
  border-top: 3px solid #40c991;
  padding-bottom: 3px;
}

.box .separator .line {
  width: 1px;
  height: 10%;
  background-color: #a803a8;
  margin: 0 auto;
}

.box .separator .or {
  margin: 0 auto;
  width: fit-content;
  height: 20%;
  display: flex;
  align-items: center;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 4rem;
  color: #fff;
  margin: 0 auto;
  display: block;
  margin-top: 3rem;
}

select,
input {
  margin-top: 1rem;
  border-radius: 1rem;
}

input.vin {
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
}

select:focus,
input:focus {
  box-shadow: none;
}

input.odo {
  width: 250px;
  max-width: 250px;
  margin: 20px auto 0 auto;
}

.odo select {
  width: 70px;
}

#alert {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/userCreate.vue